import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await register(name, email, password);
      toast.success(`Welcome, ${u.name}`);
      nav("/account");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-32 pb-24 min-h-[80vh]">
      <div className="max-w-md mx-auto px-6">
        <div className="label-eyebrow mb-4">Account</div>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tighter">
          Create account
        </h1>

        <form onSubmit={submit} className="mt-12 space-y-8">
          <label className="block">
            <span className="label-eyebrow block mb-2">Full name</span>
            <input
              type="text"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full bg-transparent border-b border-[#e5e5e5] py-3 text-base focus:outline-none focus:border-[#111] transition-colors"
              data-testid="register-name"
            />
          </label>
          <label className="block">
            <span className="label-eyebrow block mb-2">Email</span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-[#e5e5e5] py-3 text-base focus:outline-none focus:border-[#111] transition-colors"
              data-testid="register-email"
            />
          </label>
          <label className="block">
            <span className="label-eyebrow block mb-2">Password</span>
            <input
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-b border-[#e5e5e5] py-3 text-base focus:outline-none focus:border-[#111] transition-colors"
              data-testid="register-password"
            />
          </label>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#111] text-white px-8 py-4 text-sm font-medium hover:bg-[#333] transition-colors disabled:opacity-60"
            data-testid="register-submit"
          >
            {loading ? "Creating…" : "Create account"}
          </button>
        </form>

        <p className="mt-8 text-sm text-[#666]">
          Already have an account?{" "}
          <Link to="/login" className="text-[#111] font-medium hover:opacity-70">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
